import { render } from "./IconMenu.vue?vue&type=template&id=dbae5e9a"
import script from "./IconMenu.vue?vue&type=script&lang=js"
export * from "./IconMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\aa\\Desktop\\Client-files\\BB\\BB_Web\\bb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__